// import domReady from '@roots/sage/client/dom-ready';

// domReady(async () => {
//   jQuery(document).ready(function($) {
    
//     $(document).on('click', '.select-variation-and-add', function(e) {
//       e.preventDefault();
      
//       const $button = $(this);
//       const $form = $('form.variations_form');
      
//       if ($form.length === 0) {
//         console.error('No variation form found');
//         return;
//       }
      
//       // Get data
//       const variationId = $button.data('variation-id');
//       const productId = $button.data('product-id') || $form.data('product_id');
      
//       console.log('=== Starting Add to Cart ===');
//       console.log('Variation ID:', variationId);
//       console.log('Product ID:', productId);
      
//       // Loading state
//       $button.prop('disabled', true).addClass('loading');
//       const originalText = $button.text();
//       $button.text('Adding...');
      
//       // Get all data attributes from the button
//       const buttonAttrs = $button[0].attributes;
//       const attributesToSet = {};
      
//       // Loop through all attributes to find variation attributes
//       for (let i = 0; i < buttonAttrs.length; i++) {
//         const attr = buttonAttrs[i];
//         if (attr.name.startsWith('data-attribute')) {
//           // Remove 'data-' prefix to get the actual attribute name
//           const attrName = attr.name.replace('data-', '');
//           attributesToSet[attrName] = attr.value;
//           console.log('Found attribute:', attrName, '=', attr.value);
//         }
//       }
      
//       // Now set these attributes in the form
//       $.each(attributesToSet, function(attrName, attrValue) {
//         // Try to find the select/input with this name
//         const $field = $form.find(`select[name="${attrName}"], input[name="${attrName}"]`);
        
//         if ($field.length) {
//           console.log('Setting', attrName, 'to', attrValue);
//           $field.val(attrValue).trigger('change');
//           console.log('Value after set:', $field.val());
//         } else {
//           console.warn('Field not found for:', attrName);
//           console.log('Available selects:', $form.find('select').map(function() {
//             return $(this).attr('name');
//           }).get());
//         }
//       });
      
//       // Set hidden fields
//       $form.find('input[name="variation_id"]').val(variationId);
//       $form.find('input[name="product_id"]').val(productId);
      
//       console.log('Hidden fields set');
//       console.log('variation_id:', $form.find('input[name="variation_id"]').val());
//       console.log('product_id:', $form.find('input[name="product_id"]').val());
      
//       // Wait for form to update
//       setTimeout(function() {
//         const $addToCartButton = $form.find('button.single_add_to_cart_button');
        
//         console.log('Add to cart button found:', $addToCartButton.length);
//         console.log('Button disabled:', $addToCartButton.hasClass('disabled'));
//         console.log('Button classes:', $addToCartButton.attr('class'));
        
//         if ($addToCartButton.length) {
//           // Check if variation is selected
//           if ($addToCartButton.hasClass('disabled') || $addToCartButton.hasClass('wc-variation-selection-needed')) {
//             console.error('Variation not properly selected');
//             $button.text('Not Available').removeClass('loading');
//             setTimeout(function() {
//               $button.text(originalText).prop('disabled', false);
//             }, 2000);
//             return;
//           }
          
//           console.log('Triggering add to cart click');
//           $addToCartButton.trigger('click');
          
//           // Listen for success
//           $(document.body).one('added_to_cart', function(event, fragments, cart_hash) {
//             console.log('✓ Product added to cart successfully!');
//             $button.text('Added!').removeClass('loading').addClass('added');
            
//             setTimeout(function() {
//               $button.text(originalText).removeClass('added').prop('disabled', false);
//             }, 2000);
//           });
          
//           // Fallback timeout
//           setTimeout(function() {
//             if ($button.hasClass('loading')) {
//               console.warn('Timeout reached, resetting button');
//               $button.text(originalText).removeClass('loading').prop('disabled', false);
//             }
//           }, 5000);
//         } else {
//           console.error('Add to cart button not found');
//           $button.text(originalText).removeClass('loading').prop('disabled', false);
//         }
//       }, 800); // Increased timeout to allow WooCommerce to process
//     });
//   });
// });

import domReady from '@roots/sage/client/dom-ready';

domReady(async () => {
  jQuery(document).ready(function($) {
      const wcDirectCart=window?.wpData;
    // Direct add to cart - no form needed
    $(document).on('click', '.select-variation-and-add', function(e) {
      e.preventDefault();
      
      const $button = $(this);
      const productId = $button.data('product-id');
      const variationId = $button.data('variation-id');
      const quantity = $button.data('quantity') || 1;
      
      console.log('=== Direct Add to Cart ===');
      console.log('Product ID:', productId);
      console.log('Variation ID:', variationId);
      console.log('Quantity:', quantity);
      
      // Validate
      if (!productId || !variationId) {
        console.error('Missing product or variation ID');
        alert('Invalid product selection');
        return;
      }
      
      // Loading state
      $button.prop('disabled', true).addClass('loading');
      const originalText = $button.text();
      $button.text('Adding...');
      
      // AJAX request
      $.ajax({
        url: wcDirectCart.ajaxUrl,
        type: 'POST',
        data: {
          action: 'direct_add_variation_to_cart',
          product_id: productId,
          variation_id: variationId,
          quantity: quantity,
          nonce: wcDirectCart.nonce
        },
        success: function(response) {
          if (response.success) {
            console.log('✓ Success:', response.data);
            
            // Update cart fragments if available
            if (response.data.fragments) {
              $.each(response.data.fragments, function(key, value) {
                $(key).replaceWith(value);
              });
            }
            
            // Success state
            $button.text('Added to Cart!').removeClass('loading').addClass('added');
            
            // Show notification
            showNotification(response.data.message || 'Product added to cart!', 'success');
            
            // Trigger WooCommerce event
            $(document.body).trigger('added_to_cart', [
              response.data.fragments, 
              response.data.cart_hash, 
              $button
            ]);
            
            // Update cart count if element exists
            if (response.data.cart_count) {
              $('.cart-count, .cart-contents-count').text(response.data.cart_count);
            }
            
            // Reset button after 2 seconds
            setTimeout(function() {
              $button.text(originalText).removeClass('added').prop('disabled', false);
            }, 2000);
            
          } else {
            // Error from server
            console.error('Server error:', response.data);
            showNotification(response.data.message || 'Could not add to cart', 'error');
            $button.text(originalText).removeClass('loading').prop('disabled', false);
          }
        },
        error: function(xhr, status, error) {
          console.error('AJAX error:', error);
          console.error('Response:', xhr.responseText);
          showNotification('Error adding product to cart', 'error');
          $button.text(originalText).removeClass('loading').prop('disabled', false);
        }
      });
    });
    
    // Simple notification function
    function showNotification(message, type = 'success') {
      // Remove existing notifications
      $('.wc-notification').remove();
      
      const notification = $('<div>')
        .addClass('wc-notification wc-notification-' + type)
        .text(message)
        .css({
          position: 'fixed',
          top: '15px',
          right: '20px',
          padding: '0.5rem 1.5rem',
          background: type === 'success' ? '#10b981' : '#ef4444',
          color: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          zIndex: '9999',
          fontSize:'14px',
          animation: 'slideIn 0.3s ease-out'
        });
      
      $('body').append(notification);
      
      setTimeout(function() {
        notification.css('animation', 'slideOut 0.3s ease-out');
        setTimeout(function() {
          notification.remove();
        }, 300);
      }, 3000);
    }
  });
});